import styled from "styled-components";
import { Form } from "react-bootstrap";

export const FormGroup = styled(Form.Group).attrs({
  className: "FormGroup",
})`
  flex-grow: 1;
  flex-basis: 0;
  min-width: 0;
`;
